import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '../../../Box';
import { NavigationBarRoutesItem } from '../NavigationBarRoutesItem/NavigationBarRoutesItem';
import useTokens from '../../../utils/useTokens';
const StyledNavigationBarContaineer = styled(Box)(() => {
    const tokens = useTokens();
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.navigationNavContainerPrimarySpaceBetween,
        flex: 0,
        height: '100%'
    };
});
export const NavigationBarRoutes = (props) => {
    const { routes, setSubmenuRoute, activeIndexes, focusedIndexes, onNavigate, isMenuOpen } = props;
    return (React.createElement(StyledNavigationBarContaineer, { "data-testid": "navigation-bar-routes" }, routes.map((route, index) => (React.createElement(NavigationBarRoutesItem, { label: route.name, key: route.path, onClick: () => {
            setSubmenuRoute(route, index);
            if (!route.children && route.path) {
                onNavigate(route.path);
            }
        }, isFinalPath: !route.children, path: route.path, icon: route.icon, active: activeIndexes.includes(index), focused: focusedIndexes.includes(index), disabled: route.disabled, isMenuOpen: isMenuOpen })))));
};
//# sourceMappingURL=NavigationBarRoutes.js.map